import React from 'react'
import { actions } from '../../../../../store/reducers/assignment.reducer'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons'

const CollapseAllGroupsButton = () => {
    const collapsedClusterIds = useSelector(state => state.assignment.collapsedClusterIds)
    const dispatch = useDispatch()

    return (
        <Button
            onClick={() => dispatch(actions.switchAllClustersCollapse())}
            icon={collapsedClusterIds.length ? <ArrowsAltOutlined /> : <ShrinkOutlined />}
        >
            {collapsedClusterIds.length ? 'Expand all' : 'Collapse all'}
        </Button>
    )
}

export default CollapseAllGroupsButton
